module.exports = __webpack_public_path__ + "img/gntech_gallery8.3b4b48a6.jpg";